import * as React from 'react'
import { FormDataConsumer, SelectArrayInput } from 'react-admin'
import { courtLabel } from './timeslotCourts'

// Courts a timeslot is limited to; choices follow settings.available_courts.
// Leave empty for "alle banen".
const TimeslotCourtsInput = (props) => (
  <FormDataConsumer {...props}>
    {({ formData, scopedFormData, getSource, ...rest }) => {
      const available = formData?.settings?.available_courts || []
      const courtTitle = formData?.settings?.court_title
      const selected = scopedFormData?.courts || []
      const choices = [...new Set([...available, ...selected])].map((c) => ({
        id: c,
        name: courtLabel(c, courtTitle),
      }))
      return (
        <SelectArrayInput
          {...rest}
          source={getSource('courts')}
          label="Banen/zalen (leeg = alle)"
          choices={choices}
        />
      )
    }}
  </FormDataConsumer>
)

export default TimeslotCourtsInput
